import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import UsersAPI from "../../../apis/adminApi/userAPI";
import Pagination from "../../assets/Pagination";
import TableLoader from "../../loaders/TableLoader";

const PassengersIndex = () => {


    const [passengers, setPassengers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    //Permet d'aller recuperer les invoices
    const fetchPassengers = async () => {
        try{
            const data =  await UsersAPI.findPassengers();
            setPassengers(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des clients !");
        }
    };

    useEffect(() => {
        fetchPassengers();
    },[]);



    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 500;

    //Filtrage des buses en fonction de la recherche

    const filteredPassengers = passengers.filter(
        v =>
            v.name.toLowerCase().includes(search.toLowerCase()) ||
            v.phone.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedPassengers = Pagination.getData(
        filteredPassengers,
        currentPage,
        itemsPerPage
    );



    let count = 1;


    return (
        <>
            <div className="pagetitle">
                <h1>Les Clients</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/admin">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Nos clients KKS</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-lg-9">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <h5 className="card-title">Total : {passengers ? passengers.length : 0} passages</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <input type="text" onChange={handleSearch} value={search} autoComplete="off" className="form-control" placeholder="Rechercher ..." />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <Link className="btn btn-outline-success" to="#">
                                            Envoyer un message <i className="bi bi-envelope"></i>
                                        </Link>
                                    </div>
                                </div>
                                <table className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Telephone</th>
                                    </tr>
                                    </thead>
                                    {!loading && <tbody>
                                    {paginatedPassengers.map((driver) => (
                                        <tr key={driver.id}>
                                            <th scope="row">{count++}</th>
                                            <td>{driver.name}</td>
                                            <td>{driver.phone}</td>
                                        </tr>
                                    ))
                                    }

                                    </tbody> }
                                </table>

                                {loading && <TableLoader width={500} height={550} />}

                                {itemsPerPage < filteredPassengers.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredPassengers.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PassengersIndex;

